import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const AuthorPageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default AuthorPageLayout;
